import router from "./routerInstance";

interface RouteHistoryState {
    owaRouteHistoryIndex?: number;
}

let backNavigationPending = false;
let historyListenerRegistered = false;

export function initializeRouteHistory(): void {
    if (!historyListenerRegistered) {
        window.addEventListener("popstate", onHistoryChanged);
        historyListenerRegistered = true;
    }
    
    ensureRouteHistoryIndex();
}

export function setRouteWithHistory(route: string): void {
    const index = ensureRouteHistoryIndex();
    router.setRoute(route);
    setRouteHistoryIndex(index + 1);
    backNavigationPending = false;
}

export function navigateToPreviousRoute(): void {
    const index = getRouteHistoryIndex();
    // Do not traverse untracked history, including sign-in pages and flows that clear state.
    if (index !== undefined && index > 0 && !backNavigationPending) {
        backNavigationPending = true;
        window.history.back();
    }
}

function onHistoryChanged(): void {
    backNavigationPending = false;
}

function ensureRouteHistoryIndex(): number {
    const index = getRouteHistoryIndex();
    if (index !== undefined) {
        return index;
    }
    
    setRouteHistoryIndex(0);
    return 0;
}

function setRouteHistoryIndex(index: number): void {
    window.history.replaceState({ ...window.history.state, owaRouteHistoryIndex: index }, document.title);
}

function getRouteHistoryIndex(): number | undefined {
    const state: RouteHistoryState | null = window.history.state;
    const index = state?.owaRouteHistoryIndex;
    return typeof index === "number" && Number.isSafeInteger(index) && index >= 0
        ? index
        : undefined;
}
